'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { CatModal, CatHeading } from 'components/blocks-components';
import { TaxModalServerProps } from '../types';
import { TaxModalForm } from '../tax-modal-form';
import styles from '../tax-modal.module.scss';

export const TaxModal = ({
  logoutUrl,
  taxInfo,
  children
}: TaxModalServerProps) => {
  const t = useTranslations();
  const [isTaxModalOpen, setIsTaxModalOpen] = useState<boolean>(true);

  const closeTaxModal = () => {
    setIsTaxModalOpen(false);
  };

  return (
    <CatModal
      isActive={isTaxModalOpen}
      size="sm"
      disableBackdropClick
      disableEscClick
      heading={t('CAT_USER_REGISTRATION_EMAIL_SUBJECT1')}
      headingVariant="title-sm"
      className={styles['modal_header']}
    >
      <div className="cat-u-margin-bottom-md">
        <CatHeading variant="body">{t('TAX_COLLECTION_SUBTITLE')}</CatHeading>
      </div>
      <TaxModalForm
        onClose={closeTaxModal}
        logoutUrl={logoutUrl}
        taxInfo={taxInfo}
        espot={children}
      />
    </CatModal>
  );
};
